import st from "@/styles/Ui.module.scss";
import {ClockIcon} from "@mui/x-date-pickers";
import {useTranslation} from "react-i18next";

const PayToday = () => {
    
    const {t} = useTranslation()
    
    return (
        <div className={st.pay_today}>
            <ClockIcon/>
            
            <span>
                {t("pay_today")}
            </span>
        </div>
    )
}

export default PayToday